import { CameraRoll } from "@components/camera-roll";
import { useProjects } from "@features/projects/use-projects";
import { CameraIcon, HandThumbDownIcon } from "@heroicons/react/16/solid";
import { Button, Heading } from "@radix-ui/themes";
import { Page, usePageTitle } from "@views/layout/layout";
import { Link, useParams } from "react-router-dom";
import { HomeSideBar } from "../home/index";
import { useTranslation } from "react-i18next";

export const ProjectPage = (props: { trash?: boolean }) => {
  const params = useParams();
  const projectId = params.id;
  const site = params.site;
  const { projects } = useProjects();
  const currentProject = projects.data?.find((p) => p.id === projectId);
  const { t } = useTranslation();
  usePageTitle("Photographe.ai - " + currentProject?.name || "Project");

  return (
    <Page verticalCenter={false}>
      <div className="w-full md:flex">
        <div className="">
          <HomeSideBar />
        </div>
        <div className="grow space-y-8">
          <div className="w-full space-y-4">
            <div className="px-4">
              <Heading size="4">{currentProject?.name}</Heading>

              {!props.trash && (
                <div className="mt-2 gap-2 flex-wrap flex">
                  <Link to={`/${site}/templates?project=${currentProject?.id}`}>
                    <Button>
                      <CameraIcon className="w-4 h-4" />
                      {t("projects.take_new_picture")}
                    </Button>
                  </Link>
                  <Link to={`/${site}/project/${currentProject?.id}/form`}>
                    <Button variant="soft">
                      {t("projects.modify_project")}
                    </Button>
                  </Link>
                  <Link to={`/${site}/project/${currentProject?.id}/trash`}>
                    <Button variant="soft" color="gray">
                      <HandThumbDownIcon className="w-4 h-4" />
                      {t("projects.open_rejects")}
                    </Button>
                  </Link>
                </div>
              )}

              {!!props.trash && (
                <div className="mt-2 space-x-2">
                  <Link to={`/${site}/project/${currentProject?.id}`}>
                    <Button variant="soft" color="gray">
                      Back to project
                    </Button>
                  </Link>
                </div>
              )}
            </div>

            {projectId && (
              <CameraRoll trash={props.trash} projectId={projectId} />
            )}
          </div>
        </div>
      </div>
    </Page>
  );
};
